import { useMemo } from 'react'

import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { Column } from 'react-table'

import { IncidentEvent } from '@/graphql/generated/schemas'

import {
  BULK_ACTION_CHECKBOX_COL_ID,
  IS_FLAGGED_COL_NAME,
  columns,
} from '../components/Columns'

export const useFilteredIncidentColumns = () => {
  const isBulkActionEnabled = useFeatureFlag(FeatureFlag.bulkIncidentActions)
  const isAiOperatorEnabled = useFeatureFlag(FeatureFlag.aiOperator)

  const filteredColumns = useMemo(() => {
    const excludedColumns = []

    // If AI Operator is not enabled => flag column should be hidden
    // Note: Keep the flag column visible when AI Operator is enabled, even if no incidents are currently flagged
    // This prevents column shifting when flagged incidents appear/disappear
    if (!isAiOperatorEnabled) {
      excludedColumns.push(IS_FLAGGED_COL_NAME)
    }

    // If Bulk Resolve is not enabled => action checkbox column should be hidden
    if (!isBulkActionEnabled) {
      excludedColumns.push(BULK_ACTION_CHECKBOX_COL_ID)
    }

    return filterByColumnNamesOrIds(columns, excludedColumns)
  }, [isAiOperatorEnabled, isBulkActionEnabled])

  return filteredColumns
}

export const filterByColumnNamesOrIds = (
  columns: Column<IncidentEvent>[],
  excludedColumns: string[]
): Column<IncidentEvent>[] => {
  return columns.filter(
    (col) =>
      !excludedColumns.includes(col?.accessorKey) &&
      !excludedColumns.includes(col?.id)
  )
}
